import {
  getEntityList,
  createEntity,
  getEntityDetails,
  getEntityEvents,
  getEntitiesByCategory,
} from "@/api/entities";
import notify from "@/lib/notifications";
import Entity from "@/models/Entity.model";
import { types } from "./mutations";

export default {
  /**
   * Method to fetch all entities from the API
   * Returns the entity list if present in the datasource else makes API request
   * @param
   */
  fetchEntities: async ({ commit, state, getters }) => {
    // check if enties list is non empty
    if (state.entitiesById && state.entitiesById.length > 0)
      return getters.getEntities;

    const { data, status } = await getEntityList();
    // save the entity list in store
    if (status === 200) {
      commit(
        types.SET_ENTITIES,
        data.data.reduce((result, entity) => {
          const _entity = new Entity(entity);
          result[_entity.id] = _entity;
          return result;
        }, {})
      );
      return getters.getEntities;
    } else {
      commit(types.SET_ENTITIES, {});
    }
  },

  /**
   * Action to create new entity
   */
  createNewEntity: async ({ commit }, data) => {
    const { status } = await createEntity(data);
    if (status === 200) {
      // clear all entities to reload the entity list
      commit(types.SET_ENTITIES, {});
      notify.success("Entity Created!", "Successfully created new entity");
    } else {
      notify.error("Oops! Something went wrong!");
    }
  },

  /**
   * Action to fetch a single entity,
   * returns details from the store if present in the state, else hits the api
   * @param {*} param0
   * @param {String} entity_id
   */
  fetchEntityDetails: async ({ state }, entity_id) => {
    // if preset, return from the store
    if (state.entitiesById && state.entitiesById.length > 0) {
      const entity = state.entities[entity_id];
      const datasources = Object.keys(entity.datasources).map(datasource_id => {
        return entity.datasources[datasource_id];
      });
      if (entity)
        return {
          ...entity,
          datasources,
          entity_id_col: datasources.find(item => item.type === "base")
            .entity_id_col,
        };
    }

    const { data, status } = await getEntityDetails(entity_id);
    if (status === 200) {
      return new Entity(data.data);
    } else {
      return null;
    }
  },

  fetchStaticEntities: async ({ state, commit }) => {
    if (state.staticEntitiesById && state.staticEntitiesById.length > 0) return;

    try {
      const response = await getEntitiesByCategory("static");
      const { status, data } = response;
      if (status === 200) {
        const entities = data.data;
        const indexedEntities = entities.reduce((result, entity) => {
          return Object.assign(result, {
            [entity.id]: new Entity(entity),
          });
        }, {});
        commit(types.SET_STATIC_ENTITIES, indexedEntities);
      } else {
        throw new Error("Invalid response");
      }
    } catch (error) {
      console.error(error);
    }
  },

  /**
   * Action to resets the module state with initial state
   */
  reset: async ({ commit }) => {
    commit(types.reset);
  },

  /**
   * Method to fetch all entities events from the API
   * Returns the entity event list if present in the datasource else makes API request
   * @param
   */
  fetchEntityEvents: async ({ commit, state, getters }) => {
    // check if enties events is non empty
    if (state.entityEventsById && state.entityEventsById.length > 0)
      return getters.getEntityEvents;

    const { data, status } = await getEntityEvents();
    // save the entity events in store
    if (status === 200) {
      commit(
        types.SET_ENTITY_EVENTS,
        data.data.reduce((result, entity) => {
          const _entity = entity;
          result[_entity.id] = _entity;
          return result;
        }, {})
      );
      return getters.getEntityEvents;
    } else {
      commit(types.SET_ENTITY_EVENTS, {});
    }
  },
};
